import { notify } from '@carboncopyco/ui';
import { useLocation } from 'react-router-dom';

export const useCopyUrl = () => {
  const loc = useLocation();

  const copyCurrentURL = async () => {
    try {
      const currentUrl = `${window.dsDesktop?.webAppUrl || window.origin}${
        loc.pathname
      }${loc.search}`;

      await navigator.clipboard.writeText(currentUrl);
      notify.success('Page URL was copied successfully');
    } catch (error) {
      console.error(error);
      notify.error('Page URL can not be copied');
    }
  };
  return { copyCurrentURL };
};
